import isPlainObject from 'lodash/isPlainObject';
import { unFlatten } from '@buddy-technology/ion-helpers';
import calculateIsHidden from './calculateIsHidden';

/**
 * @param  {Object[]} viewsOrFields - views or fields from ION
 * @param  {Object} rawState - top level form state
 * @returns {Object[]} - array with only views/fields that should be shown. Also removes quote and checkout views by default.
 */
const filterConditionalFieldsOrViews = (viewsOrFields, rawState, variables, offeringOptions) => {
	// Lazily compute the unflattened state. We only pay the unFlatten cost if at
	// least one item actually has a mingo-based isHidden; the common "no conditional
	// fields" case passes undefined and lets calculateIsHidden short-circuit.
	let unflattenedState;
	const filtered = viewsOrFields.filter(({
		isHidden, uiDisplay,
	}) => {
		const isHiddenProp = uiDisplay?.isHidden ? uiDisplay.isHidden : isHidden;
		if (unflattenedState === undefined && isPlainObject(isHiddenProp)) {
			unflattenedState = unFlatten(rawState);
		}
		return !calculateIsHidden(isHiddenProp, {
			variables, rawState, offeringOptions, unflattenedState,
		});
	});
	return filtered;
};

export default filterConditionalFieldsOrViews;
